import { reactive, computed } from 'vue';
import { objProp } from 'utils';

import {
  resActs,
} from './utils';

const _store = {};

export function Resource (
  { name, state = reactive({}), methods = {}, actReqs, values },
  defaults,
) {
  methods = Object.assign(
    Object.create(resActs),
    methods,
  );

  objProp(methods, '_actReqs', actReqs);

  return new Store({
    name,
    values: Object.assign(defaults.values, values),
    methods,
    state,
  });
}

function createState () {
  return reactive({
    data: undefined,
  });
}

Resource.build = function ResourceBuild (construct) {
  const state = createState();
  const length = computed(() => state.data?.length);

  const values = {
    list: computed(() => state.data),
    length,
    isEmpty: computed(() => !length.value),
    isFetching: computed(() => !state.meta || state.meta.pending),
  };
  return new Resource(construct({ state, values }), { state, values });
};

export function Entity (payload) {
  return new Store(payload);
}

export function Store ({ name, state, methods, values }) {
  // eslint-disable-next-line
  if (true && process.env.NODE_ENV === 'development') {
    [...Object.entries(methods), ...Object.entries(Object.getPrototypeOf(methods))]
      .forEach(([key, fn]) => {
        methods[key] = function reportFn (...args) {
          const info = `Store.${ name }.${ key }()`;
          const { console } = window;
          if (args.length) {
            console.groupCollapsed(info);
            console.log(...args);
            console.groupEnd();
          } else {
            console.log(info);
          }
          return fn.apply(this, args);
        };
      });
  }

  const store = reactive(Object.assign(
    Object.create(methods),
    values,
    { state },
  ));
  objProp(store, '__name', name);

  _store[name] = store;
  return store;
}

window.$store = _store;

export default _store;

export * from './utils';
